export default "__VITE_ASSET__CVSouNgs__"